import { c as _c } from "react/compiler-runtime";
import { type Address, type ChainId, ChainUtils } from '@morpho-org/blue-sdk';
import { isZeroAddressOrUnset } from '@morpho-org/ui-v6/utils';
import { memo, useMemo } from 'react';
import GuardianAddressActions from './GuardianAddressActions';
import { GuardianLabel } from './GuardianLabel';
interface GuardianAddressProps {
  chainId: ChainId;
  isAragonDAO?: boolean;
  safeQuorum?: string;
  address?: Address;
}
const GuardianAddress = t0 => {
  const $ = _c(18);
  const {
    chainId,
    isAragonDAO,
    safeQuorum,
    address
  } = t0;
  let t1;
  if ($[0] !== address) {
    t1 = !address || isZeroAddressOrUnset(address);
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMissingAddress = t1;
  let t2;
  if ($[2] !== address || $[3] !== chainId) {
    t2 = address ? ChainUtils.getExplorerAddressUrl(chainId, address) : null;
    $[2] = address;
    $[3] = chainId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const addressLink = t2;
  let t3;
  if ($[5] !== address || $[6] !== isAragonDAO || $[7] !== isMissingAddress || $[8] !== safeQuorum) {
    t3 = <GuardianLabel isAragonDAO={isAragonDAO} safeQuorum={safeQuorum} address={address} isMissingAddress={isMissingAddress} textClassName="text-xs" />;
    $[5] = address;
    $[6] = isAragonDAO;
    $[7] = isMissingAddress;
    $[8] = safeQuorum;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== address || $[11] !== addressLink || $[12] !== chainId || $[13] !== isMissingAddress) {
    t4 = !isMissingAddress && <GuardianAddressActions address={address} addressLink={addressLink} chainId={chainId} />;
    $[10] = address;
    $[11] = addressLink;
    $[12] = chainId;
    $[13] = isMissingAddress;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <div className="gap-2xs flex items-center">{t3}{t4}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
export default memo(GuardianAddress);